import { PageContainer, PageHeader, StatePanel } from '@/components/common'

export default function PrepacksHistoryPage() {
  return (
    <PageContainer>
      <PageHeader title="History" />
      <StatePanel
        state="empty"
        title="Run history is not available yet"
        description="Progress for runs you start from Schedules shows in the run queue on that tab."
      />
    </PageContainer>
  )
}
